import { guestVMsDto } from '../dto/guestVMsDto';
import { guestVMsViewModel } from '../views/guestVMsViewModel';
import { GuestVMsTableTransformer } from './GuestVMsTableTransformer';

export class GuestVMsResponseTransformer {
  public static from(guestVMs: guestVMsDto[]): guestVMsViewModel[] {
    return <guestVMsViewModel[]>guestVMs.map(x => GuestVMsTableTransformer.from(x));
  }
}
